import { ManageableProduct } from '../products';

export interface ProductsDisplaySettings {
  productPageTitle: string;
  selectedOptionIds: string[];
}

export interface ManageProductsState {
  ids: string[];
  entities: Record<string, ProductEntry>;
  productDefaults: ProductDefaults;
  displaySettings: ProductsDisplaySettings;
}

export type ProductDefaults = Pick<ManageableProduct, 'groupingName'>;

export type ProductEntry = Omit<ManageableProduct, keyof ProductDefaults>;

type Action =
  | {
      type: 'SET_PRODUCTS';
      payload: {
        products: ProductEntry[];
      };
    }
  | {
      type: 'SET_PRODUCT_DEFAULTS';
      payload: { product: ProductDefaults };
    }
  | {
      type: 'SET_DISPLAY_SETTINGS';
      payload: { displaySettings: Partial<ProductsDisplaySettings> };
    }
  | {
      type: 'UPDATE_PRODUCT';
      payload: {
        productId: string;
        updates: Partial<ManageableProduct>;
      };
    };

export const initManageProductsState: ManageProductsState = {
  ids: [],
  entities: {},
  productDefaults: {
    groupingName: 'ADDONS',
  },
  displaySettings: {
    productPageTitle: 'Build proposal',
    selectedOptionIds: [],
  },
};

export const manageProductsReducer = (
  state: ManageProductsState,
  action: Action
): ManageProductsState => {
  switch (action.type) {
    case 'SET_PRODUCTS': {
      const products = action.payload.products;
      return {
        ...state,
        ids: products.map((product) => product.pricebookId),
        entities: products.reduce<ManageProductsState['entities']>(
          (acc, product) => ({ ...acc, [product.pricebookId]: product }),
          {}
        ),
      };
    }

    case 'SET_PRODUCT_DEFAULTS':
      return {
        ...state,
        productDefaults: {
          ...action.payload.product,
        },
      };

    case 'SET_DISPLAY_SETTINGS':
      return {
        ...state,
        displaySettings: {
          ...state.displaySettings,
          ...action.payload.displaySettings,
        },
      };

    case 'UPDATE_PRODUCT': {
      const { productId, updates } = action.payload;
      if (!state.entities[productId]) {
        return state;
      }
      return {
        ...state,
        entities: {
          ...state.entities,
          [productId]: {
            ...state.entities[productId],
            ...updates,
          },
        },
      };
    }

    default:
      return state;
  }
};
